import ApplicationAdapter from './application';

export default class ApiV2Adapter extends ApplicationAdapter {
  namespace = 'api/v2';
}
